import React from 'react';
import { Archive, X } from 'lucide-react';

interface ArchiveConfirmDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const ArchiveConfirmDialog: React.FC<ArchiveConfirmDialogProps> = ({ onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex items-center mb-4">
          <div className="bg-blue-100 p-2 rounded-full mr-4">
            <Archive className="h-6 w-6 text-blue-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-800">Gebäude archivieren</h2>
        </div>
        
        <p className="text-gray-600 mb-6">
          Möchten Sie dieses Gebäude wirklich archivieren? Es wird aus der aktiven Liste entfernt und im Archiv gespeichert.
        </p>
        
        <div className="bg-blue-50 p-4 rounded-md mb-6">
          <p className="text-sm text-blue-700">
            <strong>Hinweis:</strong> Archivierte Gebäude können jederzeit wiederhergestellt werden.
          </p>
        </div>
        
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            Abbrechen
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Archivieren
          </button>
        </div>
      </div>
    </div>
  );
};